import React, { Component } from 'react';
import { withStyles } from "@material-ui/core/styles";
import ServiceComponent from "./ServiceComponent";
import { dataService } from '../../Services/data-service';

class ServicesComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            services: []
        }
    }

    componentDidMount() {
        dataService.getRestartableServices().then(restartables => this.setState({  services: restartables ? restartables.Results : [] }));
    }

    groupServicesByArea(services) {
        return services.reduce((groups, service) => {
            const area = service.WindowsServiceArea || "Unknown Area";
            if (!groups[area]) {
                groups[area] = [];
            }
            groups[area].push(service);
            return groups;
        }, {});
    }

    render() {

        const { classes } = this.props;
        const { services } = this.state;

        // Group services by WindowsServiceArea
        const groupedServices = this.groupServicesByArea(services);

        return (
            <div className={classes.services}>
                <div className={classes.title}>Services</div>
                <div className={classes.subTitle}>Restart running services</div>
                {services && services.length > 0 ? (
                    <div className={classes.serviceComponents}>
                        {Object.keys(groupedServices).map(area => (
                            <div key={area} className={classes.serviceGroup}>
                                <div className={classes.serviceAreaHeader}>{area}</div>
                                {groupedServices[area].map(service => (
                                    <ServiceComponent key={service.ID} service={service} />
                                ))}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className={classes.serviceComponents}>
                        No restartable services found
                    </div>
                )}
            </div>
        );
    }
}

const styles = {

    services: {
        width: "calc(100% - 60px)",
        padding: "16px",
        paddingBottom: "6px",
        boxSizing: "border-box",
        backgroundColor: "#FFFFFF",
        marginTop: "30px",
        marginRight: "30px",
        float: "right"
    },
    title: {
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "36px",
        color: "#707070",
        lineHeight: "180%",
        marginLeft: "5px"

    },
    subTitle: {
        fontFamily: "proxima-nova, sans-serif",
        fontSize: "20px",
        color: "#707070",
        marginTop: "5px",
        marginBottom: "29px",
        marginLeft: "5px"
    },
    serviceAreaHeader: {
        fontSize: "25px",
        // borderTop: "5px solid lightgoldenrodyellow",
        color: "#707070",
        fontWeight: "bold",
        backgroundColor: "lightgoldenrodyellow"
    },
    serviceGroup: {
        display: "flex",
        flexDirection: "column"
    }
};

export default withStyles(styles)(ServicesComponent);